import './App.css';

import Landing from './component/Landing';

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
